import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useEffect, useState } from "react";
import { useAuth } from "./Auth/AuthPage.jsx";
import {ButtonGroup, Snackbar, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import { fetchTotals } from "./upvoteTotals.js";
import { useRSVP } from './RSVPContext.jsx';

const Container = (props) => {
    const style = {
        borderRadius: "6px",
        display: "flex",
        flexDirection: "row",
        padding: "5px 0px 0px 0px",
        margin: "0px 0px 0px 0px"
    }

    return <div style={{height: "100%", verticalAlign: "middle"}}>
        <div style={style}>
            {props.children}
        </div>
    </div>
}

const RSVPButton = (props) => {
    const {isRSVP, toggle, setSnackBarMessage, setSnackBarOpen} = useRSVP()

    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const { loggedIn } = useAuth();
    const {date, venueKey} = props;
    const rsvpKey = date + "-" + venueKey
    const selected = isRSVP(rsvpKey)

    useEffect(() => {
        let active = true;
        fetchTotals().then(totals => {
            if (active && totals?.[rsvpKey]) setTotal(totals[rsvpKey]);
        });
        return () => { active = false; };
    }, [rsvpKey]);

    const requireLogin = () => {
        setSnackBarOpen(true);
        setSnackBarMessage("You must log in to star events");
    }

    let starIcon, starHandler
    if (!loggedIn) {
        starIcon = <StarBorderIcon  style={{color: "#ffffff"}}/>
        starHandler = requireLogin
    } else if (loading) {
       starIcon = <AutorenewIcon  sx={{
           animation: "spin 2s linear infinite",
           "@keyframes spin": {
               "0%": {
                   transform: "rotate(0deg)",
               },
               "100%": {
                   transform: "rotate(360deg)",
               },
           },
       }} />
       starHandler = () => {}
   } else {
        starIcon = selected ? <StarIcon style={{color: "yellow"}} size={"small"}/> : <StarBorderIcon style={{color: "white"}}/>
        starHandler = () => {
            setTotal(t => Math.max(0, t + (selected ? -1 : 1)));
            toggle(rsvpKey, setLoading)
        }
    }

    return <Container>
        <ButtonGroup variant={"contained"} sx={{background: "#cc66cc"}} >
            <Button sx={{width: "10px", height: "22px", background: "#393536", borderRight: "1px solid #333333"}} onClick={starHandler}>
                {starIcon}
            </Button>
            {/* {loggedIn && <Button disableRipple sx={{width: "50px", height: "22px", background: "#393536", cursor: "default"}}>
                <Typography variant={"body2"} sx={{color: "#FFFFFF"}}>{total}</Typography>
            </Button>} */}
        </ButtonGroup>
    </Container>


}

const RSVPButtonLight = (props) => {
    const {isRSVP, toggle} = useRSVP()
    const [loading, setLoading] = useState(false);
    const {loggedIn } = useAuth();
    const {date, venueKey} = props;
    const rsvpKey = date + "-" + venueKey
    const selected = isRSVP(rsvpKey)
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState("");

    const requireLogin = () => {setSnackBarOpen(true); setSnackBarMessage("You must log in to star events")}

    let starIcon, starHandler
    // let lfHandler = () => setShowLFCounts(!showLFCounts)
    if (!loggedIn) {
        starIcon = <StarBorderIcon  style={{color: "#ffffff"}}/>
        starHandler = requireLogin
        // lfHandler = requireLogin

    } else if (loading) {
        starIcon = <AutorenewIcon  sx={{
            animation: "spin 2s linear infinite",
            "@keyframes spin": {
                "0%": {
                    transform: "rotate(0deg)",
                },
                "100%": {
                    transform: "rotate(360deg)",
                },
            },
        }} />
        starHandler = () => {}
    } else if (selected) {
        starIcon = <StarIcon style={{color: "yellow"}} size={"small"}/>
        starHandler = () => toggle(rsvpKey, setLoading)
    } else {
        starIcon = <StarBorderIcon style={{color: "white"}}/>
        starHandler = () => toggle(rsvpKey, setLoading)
    }

    return <Container>
        <Snackbar
            open={snackBarOpen}
            message={snackBarMessage}
            autoHideDuration={2500}
            onClose={() => setSnackBarOpen(false)}
        />
        <ButtonGroup variant={"contained"} sx={{background: "#cc66cc"}} >
            <Button sx={{width: "10px", height: "22px", background: "#393536", borderRight: "1px solid #333333"}} onClick={starHandler}>
                {starIcon}
            </Button>
        </ButtonGroup>
    </Container>


}


export { RSVPButton, RSVPButtonLight };